import style from "./RegisterOTPStep.module.css";

import { useFormWithValidation } from "@/features/forms/hooks/useFormWithValidation";
import { FormProvider } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import FormOTP from "@/features/forms/components/FormOTP";
import { useCheckVerificationCode } from "../../hooks/useCheckVerificationCode";
import Spinner from "@/features/forms/components/Spinner";
import { errorToast } from "@/ui/toast/Toast";
import i18n from "@/i18n";
import { fieldErrorText } from "@/features/forms/fieldErrorText";

import envelopeBack from "@/assets/images/decorative/envelope-back.svg";
import envelopeFront from "@/assets/images/decorative/envelope-front.svg";

import Icon from "@/ui/icon/Icon";

import Button from "@/ui/button/Button";

export default function RegisterOTPStep({
	email,
	code,
	setCode,
	prevStep,
	nextStep,
}) {
	const { t } = useTranslation();
	const formMethods = useFormWithValidation({
		defaultValues: {
			code: code,
		},
	});
	const { checkCode } = useCheckVerificationCode();
	const {
		handleSubmit,
		formState: { isSubmitting },
	} = formMethods;

	const onSubmit = async function (data) {
		try {
			await checkCode({
				email: email,
				code: data.code,
			});
		} catch (e) {
			if (e?.response?.data?.errors?.email?.length) {
				const fieldError = e.response.data.errors.email[0];
				errorToast(
					fieldErrorText(
						{ ...fieldError, code: fieldError?.code ?? fieldError?.error_code },
						i18n.resolvedLanguage,
						i18n
					)
				);
				prevStep();
			}
			throw e;
		}
		setCode(data.code);
		nextStep();
	};

	return (
		<div className={style.container}>
			<div className={style.back}>
				<Icon icon="fa-arrow-left" />
				<span onClick={prevStep}>{t("common:actions.back")}</span>
			</div>
			<div className={style.header}>
				<div className={style.letter}>
					<div className={style.emailAnimation}>
						<img src={envelopeBack} className={style.envBack} />
						<img src={envelopeFront} className={style.envFront} />

						<div className={style.envelope}>
							<Icon icon="fa-key-skeleton" />
							<span>***</span>
						</div>
					</div>
				</div>
				<h2>{t("auth:register.otp.title")}</h2>

				<p>
					<Trans
						i18nKey="auth:register.otp.sent"
						values={{ email }}
						components={{ email: <span /> }}
					/>
				</p>
			</div>

			<FormProvider {...formMethods}>
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className={style.inputHolder}>
						<FormOTP name="code" />
					</div>
					<div className={style.footer}>
						<div className={style.buttonHolder}>
							<Button type="accent">
								{isSubmitting ? (
									<Spinner />
								) : (
									t("common:actions.continue")
								)}
							</Button>
						</div>
					</div>
				</form>
			</FormProvider>
		</div>
	);
}
